/** Coerce Postgres numeric strings so auction math is numeric, not concat. */
export function parseMoney(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

export function minNextBid(currentBid, startingBid) {
  return parseMoney(currentBid || startingBid) + 1;
}

export function formatAuctionMoney(value) {
  return parseMoney(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const MONEY_KEYS = [
  'current_bid', 'starting_bid', 'price', 'buy_it_now_price',
  'reserve_price', 'deposit_amount', 'weekly_rate', 'flash_sale_original_price',
];

function coerceBid(bid) {
  if (!bid || typeof bid !== 'object') return bid;
  const raw = bid.amount ?? bid.bid_amount ?? bid.price;
  if (raw == null || raw === '') return bid;
  return { ...bid, amount: parseMoney(raw) };
}

export function coerceListingMoney(listing) {
  if (!listing || typeof listing !== 'object') return listing;
  const next = { ...listing };
  for (const key of MONEY_KEYS) {
    if (next[key] != null && next[key] !== '') next[key] = parseMoney(next[key]);
  }
  if (Array.isArray(next.recentBids)) {
    next.recentBids = next.recentBids.map(coerceBid);
  }
  return next;
}

export function coerceListingPayload(data) {
  if (!data || typeof data !== 'object') return data;
  let next = data;
  if (next.listing) next = { ...next, listing: coerceListingMoney(next.listing) };
  if (Array.isArray(next.listings)) next = { ...next, listings: next.listings.map(coerceListingMoney) };
  if (next.currentBid != null && next.currentBid !== '') {
    next = { ...next, currentBid: parseMoney(next.currentBid) };
  }
  if (Array.isArray(next.recentBids)) next = { ...next, recentBids: next.recentBids.map(coerceBid) };
  return next;
}
